import type { Confirmation } from '../../domain/epharm';

type DeliveryAddressProps = {
  address: Confirmation['delivery_address'];
};

function DeliveryAddress({ address }: DeliveryAddressProps) {
  return (
    <div className="center-items">
      <div
        style={{
          flex: 0.7,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '2vh',
        }}
      >
        <h3 className="header">Confirm your delivery address</h3>
        <p
          style={{
            marginTop: 0,
            marginBottom: '3vh',
            width: '63%',
            color: '#868080',
            lineHeight: '1.5em',
            textAlign: 'center',
          }}
        >
          If your address is not correct please contact ePharmNI on{' '}
          <a href="mailto:info@epharmni.co.uk">info@epharmni.co.uk</a> and please do not complete payment until the
          address change is confirmed by the pharmacy.
        </p>
      </div>
      <div style={{ flex: 1, width: '100%' }}>
        <p
          style={{
            border: '1px solid rgba(0, 0, 0, 0.12)',
            padding: '4% 3%',
            margin: '0 7% 3% 7%',
            lineHeight: '1.5em',
            color: '#00000099',
          }}
        >
          {address.line_1 && (
            <>
              {address.line_1},
              <br />
            </>
          )}
          {address.line_2 && (
            <>
              {address.line_2},
              <br />
            </>
          )}
          {address.city && (
            <>
              {address.city},
              <br />
            </>
          )}
          {address.country && (
            <>
              {address.country},
              <br />
            </>
          )}
          {address.state && (
            <>
              {address.state},
              <br />
            </>
          )}
          {address.postcode && <>{address.postcode}</>}
        </p>
      </div>
    </div>
  );
}

export default DeliveryAddress;
